import ModuleBase, { moduleInit } from "../../../../framework/core/mvvm/module_base";
import HallBaseView from "./hallbase_view";
import ModuleManager from "../../../../framework/core/module_manager";
import GameUtil from "../../../../utility/game_util";
import AppData from '../../../public/const/app_data';

const { ccclass, menu} = cc._decorator;


@ccclass
@menu("package/hall/hall/hallbase")
@moduleInit("HallBase")
export default class HallBase extends ModuleBase<HallBaseView, null> {
    mGameList = null;

    release = false

    constructor() {
        super();
        this.windowPrefabResPath = "package/hall/module/hall/hall_base";
        this.viewType = HallBaseView;
    }

    onLoad() {
        // ModuleManager.instance.hideModule("NetPrompt")
        this.eventBind("hall_show_type", (data) => {
            cc.log("eventBind", "hall_show_type", data)
            this.view.background2.active = false
            this.view.tweenTo(data)
            // this.view.role.active = (data != "LoadingToLogin")
            // this.view.chuan2.active = (data == "LoginToHall")
        })
        this.eventBind("goldentrance_show_type", (data) => {
            // this.view.role.active = true
            this.view.background2.active = true
            this.view.tweenTo(data)
        })

        if (CC_PREVIEW && AppData.widescreenOffset) {
            GameUtil.loadRes("package/public/public_iphoneX", function (err, prefab: cc.Prefab) {
                let newNode = cc.instantiate(prefab)
                ModuleManager.instance.highest.addChild(newNode);
            })
        }
    }
  
   
    isGoldEntranceShow() {
        // this.view.role.active = false
        this.view.background2.active = true
        // this.view.bgDecorate.active = false;
    }

    
    hallShow(){

        //this.view.bgDecorate.active = false;
    }

    onHide() {
        this.view.tweenTo("LoginToHall")
    }

}

